<template>
<div class="instruction" name="instruction">
  <topNav :title="title"></topNav>
  <div class="procedure">
    <div class="bb"><img src="../../../static/images/s1.png" alt=""></div>
    <div class="tt">
      <p></p>
      <div class="line">
      <h6>点击开通</h6>
    </div>
    </div>
    <div class="pro"><img src="../../../static/images/s2.png" alt=""></div>
    <div class="pro"><img src="../../../static/images/s3.png" alt=""></div>
    <div class="tt">
      <p></p>
      <div class="line">
      <h6>绑定车牌</h6>
    </div>
    </div>
     <div class="pro"><img src="../../../static/images/s4.png" alt=""></div>
     <div class="tt">
      <p></p>
      <div class="line">
         <h6>开通免密</h6>
      </div>
    </div>
    <div class="pro"><img src="../../../static/images/s5.png" alt=""></div>
        <div class="tt">
      <p></p>
      <div class="line">
         <h6>开通成功</h6>
      </div>
    </div>
    <div class="pro"><img src="../../../static/images/s6.png" alt=""></div>
  </div>
</div>

</template>
<script>
import topNav from "../topnav/topnav"
export default {
  name: 'instruction',
  components:{
     topNav,
  },
  data() {
    return {
      title:"使用说明"
    }
  }

}
</script>
<style scoped>
.instruction{
  background: white;
  height: 100%;
  width: 100%;
}
.tt{
  width: 67%;
  margin: 27px auto;
  position: relative;
}
.tt h6{
  width: 100px;
  margin: 0 auto;
  background: white;
  color: #2EB3FF;
}
.tt p{
  border-bottom: 1px solid #cccbcb;
}
.procedure .bb img{
  width: 100%;
}
.line{
  width: 100%;
  position: absolute;
  top: -7px;
}
.pro img{
  width: 80%;
  -webkit-box-shadow:0 0 28px rgba(52, 64, 64, 0.2);
  -moz-box-shadow:0 0 28px rgba(52, 64, 64, 0.2);
  box-shadow:0 0 28px rgba(52, 64, 64, 0.2);
  margin-bottom: 12px;
}
</style>




// WEBPACK FOOTER //
// src/components/menu/instruction.vue